import React, { useEffect, useState } from "react";
import arrow from "../../../../assets/down_arrow_blue.svg";
import deleteIcon from "../../../../assets/delete_icon_pre.svg";
import { ClickAwayListener } from "@material-ui/core";
import moment from "moment";
import "./sectionDetailsDropdown.scss";
import SearchBarWithIcon from "../../../common/Modules/SearchBarWithIcon";
import { SECTIONAL_TEMPLATES } from "../../ERXConstants/constants";

function SectionDetailsDropdown({
  comp,
  selectedSectionTemp,
  setSelectedSectionTemp,
  onSectionTempDelete,
  sectionalTemplateList,
  getSectionalTemplates,
  setIsTemplateSelected,
}) {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [list, setList] = useState([]);

  useEffect(() => {
    if (Object.entries(sectionalTemplateList)?.length > 0) {
      afterFetchingSectionalTemp(sectionalTemplateList);
    }
  }, [sectionalTemplateList, searchVal]);

  //   dummy data ====>

  const createTemplateList = (tempsList, obj, selected) => {
    return tempsList.push({
      template_id: obj.id,
      template_name: obj.template_name,
      created_at: obj.created_at,
      section_details: obj.section_details,
      selected: selected,
    });
  };

  const afterFetchingSectionalTemp = (data) => {
    const addToArr = (temps) => {
      let tempsList = [];
      if (searchVal) {
        let foundObj = temps.filter((obj) => {
          return obj?.template_name
            ?.toLowerCase()
            ?.includes(searchVal?.toLowerCase());
        });
        if (foundObj) {
          foundObj.forEach((obj) => {
            let selected = false;
            if (
              obj.id === selectedSectionTemp[comp.templateTitle].template_id
            ) {
              selected = selectedSectionTemp[comp.templateTitle].selected;
            }
            return createTemplateList(tempsList, obj, selected);
          });
        }
      } else {
        temps.forEach((obj) => {
          let selected = false;
          if (obj.id === selectedSectionTemp[comp.templateTitle].template_id) {
            selected = selectedSectionTemp[comp.templateTitle].selected;
          }
          return createTemplateList(tempsList, obj, selected);
        });
      }

      return tempsList;
    };
    if (comp.templateTitle === SECTIONAL_TEMPLATES.DRUG_TEMPLATE) {
      if (data.drug_templates.length > 0) {
        let drugTemp = addToArr(data.drug_templates);
        setList([...drugTemp]);
      } else {
        setList([]);
      }
    }
    if (comp.templateTitle === SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE) {
      if (data.dignosis_template.length > 0) {
        let diagTemp = addToArr(data.dignosis_template);
        setList([...diagTemp]);
      } else {
        setList([]);
      }
    }
    if (
      comp.templateTitle ===
      SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE
    ) {
      if (data.suggested_investigation_template.length > 0) {
        let siTemp = addToArr(data.suggested_investigation_template);
        setList([...siTemp]);
      } else {
        setList([]);
      }
    }
  };

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
    setSearchVal("");
  };

  const sectionPrefilledRxDetailsDropdown = () => {
    return (
      <ClickAwayListener onClickAway={toggleDropdown}>
        <div className="section-rx-details-dropdown">
          {displaySavedSectionTemplates()}
        </div>
      </ClickAwayListener>
    );
  };

  const onClickSectionTemplate = (item) => {
    let duplicatedList = [...list];
    duplicatedList.forEach((ob) => {
      if (item.template_name === ob.template_name) {
        ob.selected = true;
      } else {
        ob.selected = false;
      }
    });
    if (comp.templateTitle === SECTIONAL_TEMPLATES.DRUG_TEMPLATE) {
      setIsTemplateSelected(true);
    }
    setList(duplicatedList);
    setSelectedSectionTemp({
      ...selectedSectionTemp,
      [comp.templateTitle]: item,
    });
    getSectionalTemplates();
    toggleDropdown();
  };

  const displaySavedSectionTemplates = () => {
    return (
      <div className="section-details-dropdown-values">
        <div className="section-details-dropdown-searchbar">
          <SearchBarWithIcon
            placeholder={comp?.templateSearchPlaceholder ?? "Search Template"}
            inputCallBack={(val) => {
              setSearchVal(val);
            }}
          />
        </div>
        {list.length > 0 ? (
          list?.map((item) => (
            <div
              key={item?.template_id}
              className={
                "section-details-dropdown-options " +
                (item.selected
                  ? "section-details-dropdown-options-selected"
                  : "")
              }
              onClick={() => onClickSectionTemplate(item)}
            >
              <div className="section-details-dropdown-value-container">
                <div>
                  <div
                    className="saved-rx-template-name"
                    style={{ color: item.selected ? "#fff" : "" }}
                  >
                    {item.template_name}
                  </div>
                  <div
                    className="saved-rx-template-date"
                    style={{ color: item.selected ? "#fff" : "" }}
                  >
                    {moment(item.created_at).utc().format("DD MMMM, YYYY")}
                  </div>
                </div>
                {item?.template_id && (
                  <div className="section-details-dropdown-buttons-container">
                    <div className="section-details-dropdown-delete-container">
                      <div
                        className="section-details-dropdown-delete-button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          onSectionTempDelete(
                            item.template_id,
                            comp.templateTitle
                          );
                        }}
                      >
                        <img
                          src={deleteIcon}
                          alt=""
                          className="section-details-dropdown-delete-icon"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="section-details-dropdown-empty">No options</div>
        )}
      </div>
    );
  };

  return (
    <div className="section-details-dropdown-cont">
      <div className="section-details-header-cont" onClick={toggleDropdown}>
        <div className="section-details-header">{comp.templateTitle}</div>
        <img
          src={arrow}
          alt=""
          className={
            "section-details-header-arrow " +
            (openDropdown ? "up-arrow" : "down-arrow")
          }
        />
      </div>
      {openDropdown && sectionPrefilledRxDetailsDropdown()}
    </div>
  );
}

export default SectionDetailsDropdown;
